import AOS from 'aos';
import 'aos/dist/aos.css';

export function initAos() {
	const elements = document.querySelectorAll('[data-aos]');

	if (!elements.length) {
		return;
	}

	AOS.init({
		disable: false,
		startEvent: 'DOMContentLoaded',
		initClassName: 'aos-init',
		animatedClassName: 'aos-animate',
		useClassNames: false,
		disableMutationObserver: false,
		debounceDelay: 50,
		throttleDelay: 99,
		offset: 100,
		delay: 100,
		duration: 800,
		easing: 'ease',
		once: true,
		mirror: false,
		anchorPlacement: 'top-bottom',
	});
}
